import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Image} from '@jobseeker/lotus/components/Image';

const PendingComponent = () => {
  const theme = useWrappedTheme();

  return (
    <Box
      sx={{
        backgroundColor: 'border.main',
        minHeight: 99,
        display: 'flex',
        alignItems: 'start',
        paddingTop: 12,

        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          maxWidth: 1640,
          width: 1048,
          height: '300px',
          padding: theme.spacing(6, 4),
          backgroundColor: 'primary.contrastText',
          borderRadius: 2,
          boxShadow: '0px 6.48px 6px 2px rgba(41, 41, 41, 0.04)',
          textAlign: 'center',
          marginBottom: '500px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{display: 'flex', justifyContent: 'center', marginBottom: 2}}>
          <Image
            src={`${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/pending.png`}
            width={48}
            height={47}
            alt="Transaction Pending"
          />
        </Box>
        <Typography
          sx={{
            fontSize: theme.typography.pxToRem(18),
            fontWeight: 600,
            lineHeight: '32px',
            textAlign: 'center',
            color: 'secondary.dark',
            marginBottom: 1,
          }}
        >
          {process.env.NEXT_PUBLIC_APP_DOMAIN} Pro Membership Plan - Transaction
          Pending
        </Typography>
      </Box>
    </Box>
  );
};

export default PendingComponent;
